<app-access-manager [namespace]="PAGE_ACCESS_NAMESPACE">

  <div [hidden]="this.storage.getCurrentUser().originalRole != 'portal.merchant'">
    <app-merchant-header></app-merchant-header>
  </div>

  <div [hidden]="renderTable">You must select a merchant first.</div>
  <div [hidden]="!renderTable">
    <app-filterable-table
      #customersTable
      [tableView]="tableView"
      [options]="options"
      [title]="'CUSTOMERS'"
      (selectedRecord)="editingCustomer ? null : handleCustomerSelected($event)"
      [toolbarButtonText]="'Add New Customer'"
      (toolbarButtonClick)="editingCustomer ? null : btnInitNewCustomer_click()"
    ></app-filterable-table>
  </div>

</app-access-manager>